import { QuickTable, QuickTableFilterTabs } from "../../components";
import { beneficiariesDisplayFormatter } from "./beneficiariesDisplayFormatter";
import { IBeneficiaryViewProps } from "./Beneficiaries";
import { BankBeneficiaryDetailsModal } from "./BankBeneficiaryDetailsModal";
import { Route, Routes } from "react-router-dom";
import { CreateBeneficiaryForm } from "./CreateBeneficiaryForm/CreateBeneficiaryForm";
import { GatewayBeneficiaryDetailsModal } from "./GatewayBeneficiaryDetailsModal";

export const View = (props: IBeneficiaryViewProps) => {
  return (
    <>
      <QuickTable
        id="beneficiariesTable"
        data={props.data}
        headers={props.headers}
        isLoading={props.isLoading}
        isError={props.isError}
        itemCount={props.totalCount}
        // renderDetail={(item) => item.beneficiaryTransactions} // get with another api call
        toolbarTabs={
          <QuickTableFilterTabs
            queryStringTabNavLinks={props.queryStringTabs}
          />
        }
        displayFormatter={beneficiariesDisplayFormatter}
        createNewButtonText="Add Beneficiary"
        openCreateNewModal={props.openCreateNewModal}
        onExport={props.onExport}
        disableClickOnTargetClassNames={["copy-btn"]}
        openDetailsModal={props.openDetailsModal}
        detailsModalKeySelector={(rowData) => ({
          id: rowData.id,
          benef_type: rowData.beneficiary_type,
        })}
      />

      <Routes>
        <Route
          path="create/bank"
          element={
            <CreateBeneficiaryForm
              refreshTable={props.refreshTable}
              goBackOnClose={false}
            />
          }
        />

        <Route
          path="bank/:id/details"
          element={<BankBeneficiaryDetailsModal />}
        />
        <Route
          path="gateway/:id/details"
          element={<GatewayBeneficiaryDetailsModal />}
        />

        {/* <Route
          path=":id/edit"
          element={<EditProductForm refreshTable={props.refreshTable} />}
        /> */}
      </Routes>
    </>
  );
};
